import { render } from "./BaseChart.vue?vue&type=template&id=17a7fe6e&ts=true"
import script from "./BaseChart.vue?vue&type=script&lang=ts"
export * from "./BaseChart.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__